import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Container } from 'react-bootstrap';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <Container className="mt-5">
                    <Alert variant="danger" className="text-center">
                        <Alert.Heading>🚫 Oops! Something went wrong</Alert.Heading>
                        <p className="mb-3">
                            We're sorry, but something unexpected happened. Please try refreshing the page.
                        </p>
                        <div className="d-grid gap-2 d-md-flex justify-content-md-center">
                            <Button 
                                variant="outline-danger" 
                                onClick={this.handleReload}
                                className="me-md-2"
                            >
                                🔄 Refresh Page
                            </Button>
                        </div>
                        {process.env.NODE_ENV === 'development' && (
                            <details className="mt-3 text-start">
                                <summary>Error Details (Development)</summary>
                                <pre className="mt-2 text-muted small">
                                    {this.state.error && this.state.error.toString()}
                                    <br />
                                    {this.state.errorInfo.componentStack}
                                </pre>
                            </details>
                        )}
                    </Alert>
                </Container>
            );
        }

        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired
};

export default ErrorBoundary;
